// Define your logger here

export const LoggerService = {
  log: (...values: unknown[]) => {
    console.log(values);
  },
};
